import { UmpireTrendsChartConfigDto, UmpireReportChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const UmpireTrendsChartSidebar = ({
  extraChartData,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<UmpireTrendsChartConfigDto, UmpireReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('UmpireTrendsChart', extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['4', '6', '8']}
        selected={extraChartData.numberOfTilesInModule.toString()}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            umpireTrendsChartConfig: { ...tempLayout.umpireTrendsChartConfig, numberOfTilesInModule: parseInt(selected) || 6 },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default UmpireTrendsChartSidebar;
